"use client";

import { Decorative } from "@faire/design-tokens";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { IBrandSubtitleProps } from "@faire/retailer-visitor-shared/src/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearchSubtitle";
import { Insider } from "@faire/web--source/slate/icons/InsiderIcon";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { Span, Typography } from "@faire/web--source/slate/Typography";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { IBrandSearchQueryUXMessaging } from "@faire/web-api--source/indigofair/data/IBrandSearchQueryUXMessaging";
import isEmpty from "lodash/isEmpty";
import React from "react";
import styled from "styled-components";

const InsiderMessage: React.FC<{
  insiderMessage: IBrandSearchQueryUXMessaging;
}> = ({ insiderMessage }) => {
  return (
    <WrappingRow>
      <Span variant="paragraphSansMedium" color={Decorative.shade.teal}>
        <ResponsiveContentV2
          mobile={insiderMessage?.mobile_message}
          tabletAndAbove={insiderMessage?.desktop_message}
        />
      </Span>
      <Spacer width={4} />
      <Insider
        small
        color={Decorative.icon.teal}
        fill={Decorative.icon.teal}
        font-size={getSpacing("2x")}
      />
    </WrappingRow>
  );
};

const BrandBasedIn: React.FC<{
  brand: IBrandSubtitleProps | undefined;
}> = ({ brand }) => {
  return (
    <ResponsiveContentV2
      mobile={
        brand?.based_in_country_message?.mobile_message ? (
          <Typography variant="paragraphSansRegular">
            {brand?.based_in_country_message?.mobile_message}
          </Typography>
        ) : null
      }
      tabletAndAbove={
        brand?.based_in_country_message?.desktop_message ? (
          <Typography variant="paragraphSansRegular">
            {brand?.based_in_country_message?.desktop_message}
          </Typography>
        ) : null
      }
    />
  );
};

export const MaybeInsiderMessageOrBrandBasedIn: React.FC<{
  isLoading: boolean;
  insiderMessage: IBrandSearchQueryUXMessaging | undefined;
  brand: IBrandSubtitleProps | undefined;
}> = ({ isLoading, insiderMessage, brand }) => {
  if (isLoading) {
    return null;
  }

  if (
    !insiderMessage ||
    (isEmpty(insiderMessage.desktop_message) &&
      isEmpty(insiderMessage.mobile_message))
  ) {
    return <BrandBasedIn brand={brand} />;
  }
  return <InsiderMessage insiderMessage={insiderMessage} />;
};

const WrappingRow = styled(Row)`
  flex-wrap: wrap;
`;
